var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDolorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FEF7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.833 34.9151C27.833 36.5318 29.083 37.8318 30.6164 37.8318H33.7497C35.083 37.8318 36.1663 36.6984 36.1663 35.2818C36.1663 33.7651 35.4997 33.2151 34.5164 32.8651L29.4997 31.1151C28.5163 30.7651 27.8497 30.2318 27.8497 28.6984C27.8497 27.2984 28.933 26.1484 30.2663 26.1484H33.3997C34.933 26.1484 36.183 27.4484 36.183 29.0651",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 24.5V39.5",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6663 32.0026C48.6663 41.2026 41.1997 48.6693 31.9997 48.6693C22.7997 48.6693 15.333 41.2026 15.333 32.0026C15.333 22.8026 22.7997 15.3359 31.9997 15.3359",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.333 17V23.6667H46.9997",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6663 15.3359L40.333 23.6693",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDolorIcon);
export default __webpack_public_path__ + "static/media/dolorIcon.fa8181e4049e38ba60126d8042982bec.svg";
export { ForwardRef as ReactComponent };